import React, { Component } from "react";
import { KEY_D } from "keycode-js";
import { Dialog, Button } from "@vitalsource/vstui";

const DebugButton = ({ onClick, children }) => {
  return (
    <Button onClick={onClick} fullWidth outline>
      {children}
    </Button>
  );
};

/**
 * For more tool references, see the legacy
 * src/js/fraction/components/library/container.jsx
 */
export default class DebugTools extends Component {
  state = {
    isOpen: false
  };

  componentDidMount() {
    window.addEventListener("keyup", this.keyUpHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.keyUpHandler);
  }

  keyUpHandler = e => {
    if (e.keyCode === KEY_D && e.altKey) {
      this.setState({
        isOpen: true
      });
    }
  };

  close = () => {
    this.setState({
      isOpen: false
    });
  };

  pointToProd = () => {
    Fraction.Helpers.setCookie("productionJigsaw", "true", 2);
    window.location.reload();
  };

  pointToDev = () => {
    Fraction.Helpers.setCookie("productionJigsaw", "");
    window.location.reload();
  };

  resetNewReaderOnboarding = () => {
    const userObj = Fraction.Helpers.getDataObject("User.Persist");
    delete userObj.NewReaderOnboarding;
    Fraction.Helpers.savePersist();
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <Dialog
        open={this.state.isOpen}
        onRequestClose={this.close}
        rootSelector="#bookshelf"
        title="Debug Menu"
        darkHeader
      >
        {window.pointingAtProd ? (
          <DebugButton onClick={this.pointToDev}>Point to Dev</DebugButton>
        ) : (
          <DebugButton onClick={this.pointToProd}>Point to Prod</DebugButton>
        )}
        <DebugButton onClick={this.resetNewReaderOnboarding}>
          Reset New Reader Onboarding
        </DebugButton>
      </Dialog>
    );
  }
}
